export enum SampleStatusEnum {
    ALL = -1,
    AVAILABLE,
    NOT_RECEIVED,
    EXPIRED,
    DISPOSED,
}
